/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { method, render } from '../lib';
import { VmVideo, VmFile } from '@vime/core';
import { define } from '../lib';
define('vm-video', VmVideo);
define('vm-file', VmFile);
export default Vue.extend({
    props: {
        willAttach: {},
        hasCustomTextManager: {},
        crossOrigin: {},
        preload: {},
        poster: {},
        controlsList: {},
        autoPiP: {},
        disablePiP: {},
        disableRemotePlayback: {},
        mediaTitle: {},
    },
    methods: {
        getAdapter: method('getAdapter'),
    },
    render: render('vm-video', []),
});
//# sourceMappingURL=Video.js.map